import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box } from '@mui/material';
import React from 'react';

type Props = {
  text: string;
  iconClassName?: string;
};

const EditableDateCell: React.FC<Props> = ({ text, iconClassName = 'edit-icon' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 1,
        height: '100%',
      }}
    >
      <span>{text}</span>
      <EditOutlinedIcon className={iconClassName} sx={{ fontSize: 16 }} />
    </Box>
  );
};

export default EditableDateCell;
